import React, { useCallback, useEffect, useRef, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
    userCoords,
} from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { Grid } from "@mui/material";
import { paisGet, SFVoucherIns, tipoDeDocumentoGet } from "services/services-mia";

const sexos = [
    { sexoCod: "M", sexoNombre: "Masculino" },
    { sexoCod: "F", sexoNombre: "Femenino" },
    { sexoCod: "X", sexoNombre: "No Binario" }
];

export default function InsertModal({ updateList, closeModal }) {
    const [inRequest, setInRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [tiposDeDocumento, setTiposDeDocumento] = useState([]);
    const [placeholderDNI, setPlaceholderDNI] = useState('');
    const [regexDNI, setRegexDNI] = useState(/./);

    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);


    const formikRef = useRef();

    const handleSubmit = async (values) => {
        setInRequest(true);

        const response = await SFVoucherIns({
            SFVoucherTipo: "A",
            numeroDesde: values.numeroDesde,
            numeroHasta: values.numeroHasta,
            cantidad: values.cantidad,
            SFVoucherFechaDesde: values.SFVoucherFechaDesde,
            SFVoucherFechaHasta: values.SFVoucherFechaHasta,
            tipoDeDocumentoCod: values.tipoDeDocumento,
            usuarioNroDeDocumentoX: values.dni,
            usuarioSexo: values.sexo,
            usuarioFechaDeNacimiento: values.fechaNacimiento,
            usuarioApellidos: values.usuarioApellidos,
            usuarioNombres: values.usuarioNombres
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            "Voucher cargado exitosamente",
            functions
        );

        setInRequest(false);
    };

    // const closeModalMapa = () => {
    //     setModalMapaOpen(false)
    // }
    const coords = useRecoilValue(userCoords);

    const getPais = useCallback(async () => {
        setIsLoading(true);
        const { result: paises, status } = await paisGet(credentials);
        if (status.code !== 1) {
            setIsLoading(false);
            return;
        }
        let paisIdSelected = paises[0].paisId;
        if (coords) {
            const { lat: userLat, lng: userLng } = coords;
            let Latitud = paises[0].paisLatitudCentro - userLat;
            let Longitud = paises[0].paisLongitudCentro - userLng;
            for (let i = 1; i < paises.length; i++) {
                const { paisLatitudCentro: lat, paisLongitudCentro: lng } = paises[i];
                if (Math.abs(lat - userLat + lng - userLng) < Math.abs(Latitud + Longitud)) {
                    paisIdSelected = paises[i].paisId;
                    Latitud = lat - userLat;
                    Longitud = lng - userLng;
                }
            }
        }
        setIsLoading(false);
        return paisIdSelected;
    }, [credentials, coords]);

    const getTiposDeDocumento = useCallback(async (paisId) => {
        if (!paisId) return;
        setIsLoading(true);
        const { result, status } = await tipoDeDocumentoGet(paisId, credentials);
        if (status.code !== 1) {
            setIsLoading(false);
            return;
        }
        setTiposDeDocumento(result);
        if (result.length > 0) {
            const first = result[0];
            formikRef.current.setFieldValue("tipoDeDocumento", first.tipoDeDocumentoCod);
            setPlaceholderDNI(first.tipoDeDocumentoPlaceholder);
            setRegexDNI(first.tipoDeDocumentoRegExp ? first.tipoDeDocumentoRegExp : "");
        }
        setIsLoading(false);
    }, [credentials]);

    useEffect(() => {
        if (Object.keys(credentials).length === 0) return;
        (async () => {
            const paisId = await getPais();
            await getTiposDeDocumento(paisId);
        })()
    }, [credentials, getPais, getTiposDeDocumento]);

    const handleNumeroChange = (e) => {
        const { name, value } = e.target;
        formikRef.current.setFieldValue(name, value);
        const desde = name === "numeroDesde" ? value : formikRef.current.values.numeroDesde;
        const hasta = name === "numeroHasta" ? value : formikRef.current.values.numeroHasta;
        const d = parseInt(desde, 10);
        const h = parseInt(hasta, 10);
        formikRef.current.setFieldValue("cantidad", !isNaN(d) && !isNaN(h) && h >= d ? h - d + 1 : "");
    };

    const handleChangeTipoDeDocumento = (event) => {
        const tipoDeDocumentoCod = event.target.value;
        const tipoDeDocumento = tiposDeDocumento.find(td => td.tipoDeDocumentoCod === tipoDeDocumentoCod);
        if (tipoDeDocumento) {
            formikRef.current.setFieldValue("tipoDeDocumento", tipoDeDocumento.tipoDeDocumentoCod);
            setPlaceholderDNI(tipoDeDocumento.tipoDeDocumentoPlaceholder);
            setRegexDNI(tipoDeDocumento.tipoDeDocumentoRegExp ? tipoDeDocumento.tipoDeDocumentoRegExp : "");
        }
    }

    const initialValues = {
        numeroDesde: "",
        numeroHasta: "",
        cantidad: "",
        SFVoucherFechaDesde: "",
        SFVoucherFechaHasta: "",
        tipoDeDocumento: "",
        dni: "",
        sexo: "M",
        fechaNacimiento: "",
        usuarioApellidos: "",
        usuarioNombres: "",
    }

    const validationSchema = yup.object({
        numeroDesde: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
        numeroHasta: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
        SFVoucherFechaDesde: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
        SFVoucherFechaHasta: yup.string(FORM_ERROR_MESSAGES.text)
            .required(FORM_ERROR_MESSAGES.required)
            .test("is-after-fecha-desde", "La fecha hasta debe ser mayor o igual a la fecha desde", function (value) {
                if (value && this.parent.SFVoucherFechaDesde) {
                    return value >= this.parent.SFVoucherFechaDesde;
                }
                return true;
            }),
        usuarioNombres: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
        usuarioApellidos: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
        tipoDeDocumento: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
        dni: yup.string(FORM_ERROR_MESSAGES.text)
            .required(FORM_ERROR_MESSAGES.required)
            .matches(regexDNI, { message: "Número de documento inválido" }),
        sexo: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
        fechaNacimiento: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
    })

    return (
        <Formik
            innerRef={formikRef}
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}

            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={`${styles["column-sm"]} ${styles["batch-container"]}`}>
                    <Grid container spacing={3}>

                        {/* Fila 1: numeroDesde · numeroHasta · cantidad */}
                        <Grid item xs={4}>
                            <FormikTextInput
                                name="numeroDesde"
                                labelText="Número desde"
                                placeholder="Número desde"
                                onChange={handleNumeroChange}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormikTextInput
                                name="numeroHasta"
                                labelText="Número hasta"
                                placeholder="Número hasta"
                                onChange={handleNumeroChange}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormikTextInput
                                name="cantidad"
                                labelText="Cantidad"
                            />
                        </Grid>

                        {/* Fila 2: FechaDesde · FechaHasta */}
                        <Grid item xs={6}>
                            <FormikTextInput
                                type="date"
                                name="SFVoucherFechaDesde"
                                labelText="Fecha desde"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormikTextInput
                                type="date"
                                name="SFVoucherFechaHasta"
                                labelText="Fecha hasta"
                            />
                        </Grid>

                        {/* Fila 3: tipoDeDocumento · dni · sexo */}
                        <Grid item xs={4}>
                            <FormikSelectInput
                                fullWidth={true}
                                name="tipoDeDocumento"
                                labelText="Tipo de doc."
                                onChange={handleChangeTipoDeDocumento}
                            >
                                {tiposDeDocumento.map(({ tipoDeDocumentoCod, tipoDeDocumentoNombre }) => (
                                    <option
                                        key={tipoDeDocumentoCod}
                                        data-id={tipoDeDocumentoCod}
                                        value={tipoDeDocumentoCod}
                                    >
                                        {tipoDeDocumentoNombre}
                                    </option>
                                ))}
                            </FormikSelectInput>
                        </Grid>
                        <Grid item xs={4}>
                            <FormikTextInput
                                name="dni"
                                placeholder={placeholderDNI}
                                labelText="Nro. de documento"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormikSelectInput
                                fullWidth={true}
                                name="sexo"
                                labelText="Género"
                            >
                                {sexos.map(({ sexoCod, sexoNombre }) => (
                                    <option key={sexoCod} value={sexoCod}>{sexoNombre}</option>
                                ))}
                            </FormikSelectInput>
                        </Grid>

                        {/* Fila 4: fechaNacimiento · apellidos · nombres */}
                        <Grid item xs={4}>
                            <FormikTextInput
                                name="fechaNacimiento"
                                labelText="Fecha de nac."
                                type="date"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormikTextInput
                                name="usuarioApellidos"
                                labelText="Apellidos"
                                placeholder="Pérez"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormikTextInput
                                name="usuarioNombres"
                                labelText="Nombres"
                                placeholder="Juan"
                            />
                        </Grid>

                    </Grid>

                    <FormButton
                        inRequest={inRequest || isLoading}
                        newFormData={{ button: "Guardar" }}
                        onCloseModal={closeModal}
                    />

                    {(inRequest || isLoading) && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
